import { render, staticRenderFns } from "./ThemeContainer.vue?vue&type=template&id=bc023b68&scoped=true&"
import script from "./ThemeContainer.vue?vue&type=script&lang=js&"
export * from "./ThemeContainer.vue?vue&type=script&lang=js&"
import style0 from "./ThemeContainer.vue?vue&type=style&index=0&id=bc023b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc023b68",
  null
  
)

export default component.exports